export default __webpack_public_path__ + "static/media/discover.24f71039.svg";